var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGutterReplacement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 39,
    viewBox: "0 0 51 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2988_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96862 24.5625L7.42682 28.2839H8.84745C8.56795 33.0026 4.70743 36.755 0 36.755V39C5.92422 39 10.7767 34.2417 11.0583 28.2839H12.5104L9.96862 24.5625Z",
    fill: "#10260F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 13.4326L25.7048 0L0.491699 13.4337V20.1847L0.529527 20.1644V28.6869L25.7458 15.2521L50.9621 28.6869V20.1644L50.9999 20.1847V13.4326ZM2.69831 14.7924L25.7069 2.53365L48.7933 14.7935V16.4751L25.7458 4.19495L2.69831 16.4741V14.7914V14.7924ZM2.73614 19.012L24.6425 7.34116V13.3065L2.73614 24.9773V19.012ZM48.7555 24.9773L26.8491 13.3065V7.38072L48.7555 19.0131V24.9773Z",
    fill: "#10260F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5022 36.9679H31.9885V23.5054H19.5022V36.9679ZM21.7088 31.3586H24.6415V34.7218H21.7088V31.3586ZM26.8492 34.7229V31.3597H29.7818V34.7229H26.8492ZM29.7818 29.1136H26.8492V25.7504H29.7818V29.1136ZM24.6425 25.7504V29.1136H21.7099V25.7504H24.6425Z",
    fill: "#10260F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2988_1947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 39,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutterReplacement);
export default __webpack_public_path__ + "static/media/gutter-replacement.cc721eb41c148bb3038eb86b65053e5c.svg";
export { ForwardRef as ReactComponent };